export const isValidTimeString = (timeString) => {
  if (typeof timeString !== 'string') return false;
  const parts = timeString.split(':');
  if (parts.length !== 2) return false;
  // Ensure both parts are non-empty
  if (parts[0].length === 0 || parts[1].length === 0) return false;
  const [hours, minutes] = parts.map(Number);
  if (
    Number.isNaN(hours) ||
    Number.isNaN(minutes) ||
    hours < 0 ||
    hours > 23 ||
    minutes < 0 ||
    minutes > 59
  ) {
    return false;
  }
  return true;
};

const timeToSeconds = (timeString) => {
  if (!isValidTimeString(timeString)) {
    throw new Error(
      'Invalid time string. Must be in HH:mm format with valid values.'
    );
  }
  const [hours, minutes] = timeString.split(':').map(Number);
  return hours * 3600 + minutes * 60;
};

export default timeToSeconds;
